import React from 'react';

const AboutPage = () => {
  return (
    <div className="flex flex-col">
      <h2 className="text-2xl font-bold mb-4">About</h2>
      <p className="text-gray-400">This is a Blog Page made using react</p>
      <p className="text-gray-400">Author: Abhiraj Sonawne</p>
    </div>
  );
};

export default AboutPage;
